import React, { useEffect, useRef, useState, useMemo } from "react";
import authenticatedFetcher from "../../services/fetcher";
import "@ckeditor/ckeditor5-build-classic/build/translations/es";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import ckUploader from "../../services/ckUploader";
import CustomModalSARChangeHoursAndRecertification from "../../components/CustomModals/CustomModalSARChangeHoursAndRecertification";
import { toastSuccess, toastError } from "../../utils/ToastConfig";

export const SarActionsTab = (props) => {
  const { userPk } = props;
  const editorRef = useRef();
  const isResettingRef = useRef(false);
  const isFetchingRef = useRef(false);
  const [isLoading, setIsLoading] = useState(false);

  // ID único para el editor CKEditor
  const editorId = useMemo(
    () =>
      `ck-sar-actions-${userPk || "new"}-${Math.random().toString(36).slice(2, 8)}`,
    [userPk],
  );
  const config = {
    fontSize: {
      options: [9, 11, 13, "default", 17, 19, 21, 24, 48],
    },
    toolbar: {
      items: [
        "Cut",
        "Copy",
        "Paste",
        "PastePlainText",
        "PasteFromWord",
        "|",
        "undo",
        "redo",
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "FontSize",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "blockQuote",
        "link",
        "mailTo",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        "alignment",
        "|",
        "ImageUpload",
        "mediaEmbed",
        "HtmlEmbed",
        "|",
        "Subtitle",
        "Warning",
        "sourceEditing",
        "Maximize",
      ],
    },
  };

  const [
    changeHoursAndRecertificationModalOpen,
    setChangeHoursAndRecertificationModalOpen,
  ] = useState(false);

  const [userData, setUserData] = useState();
  const [actionsList, setActionsList] = useState([]);
  const [actionPersonList, setActionPersonList] = useState([]);
  const [contactTypesList, setContactTypesList] = useState([]);
  const [defaultAnswerList, setDefaultAnswerList] = useState([]);
  const [recertificationGroupList, setRecertificationGroupList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [entitiesList, setEntitiesList] = useState([
    {},
    { pk: -1, name: "Otra" },
  ]);

  const [sar, setSar] = useState();
  const [sarIndex, setSarIndex] = useState();

  const [creationDate, setCreationDate] = useState();
  const [creationDatePlus15, setCreationDatePlus15] = useState();
  const [selectedActionPerson, setSelectedActionPerson] = useState();
  const [isPublicAction, setPublicAction] = useState("");
  const [selectedContactType, setSelectedContactType] = useState();
  const [selectedDefaultAnswer, setSelectedDefaultAnswer] = useState();
  const [selectedRecertificationGroup, setSelectedRecertificationGroup] =
    useState();
  const [controlDate, setControlDate] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [selectedEntity, setSelectedEntity] = useState();
  const [comments, setComments] = useState("");
  const [enterpriseName, setEnterpriseName] = useState(sar?.enterprise_name);

  const toogleModalChangeHoursAndRecertification = () =>
    setChangeHoursAndRecertificationModalOpen((prev) => !prev);

  const handleChangeCreationDate = (event) =>
    setCreationDate(event.target.value);
  const handleChangeSelectedActionPerson = (event) =>
    setSelectedActionPerson(event.target.value);
  const handleChangeIsPublicAction = (event) =>
    setPublicAction(event.target.value);
  const handleChangeSelectedContactType = (event) =>
    setSelectedContactType(event.target.value);
  const handleChangeSelectedDefaultAnswer = (event) =>
    setSelectedDefaultAnswer(event.target.value);
  const handleChangeSelectedRecertificationGroup = (event) =>
    setSelectedRecertificationGroup(event.target.value);
  const handleControlDateChange = (event) => setControlDate(event.target.value);
  const handleChangeSelectedDepartment = (event) =>
    setSelectedDepartment(event.target.value);
  const handleChangeSelectedEntity = (event) =>
    setSelectedEntity(event.target.value);
  const handleChangeEnterpsiseName = (event) =>
    setEnterpriseName(event.target.value);

  const saveData = (updateHours = false) => {
    setIsLoading(true);
    authenticatedFetcher({
      path: sar ? `/sar/${sar.id}/` : "/sar/",
      body: {
        action_date: creationDate,
        action_person: selectedActionPerson,
        is_private: isPublicAction,
        person: userPk,
        contact_type: selectedContactType,
        default_answer: selectedDefaultAnswer,
        recertification_group:
          !updateHours && sar
            ? sar.recertification_group
            : selectedRecertificationGroup,
        control_date: controlDate,
        department: selectedDepartment,
        comments: comments,
        enterprise_name: enterpriseName,
        enterprise: selectedEntity === "-1" ? null : selectedEntity,
        hours: !updateHours && sar ? sar.hours : getHours(),
      },
      method: sar ? "PATCH" : "POST",
    })
      .then(() => {
        toastSuccess(
          sar
            ? "Acción actualizada correctamente."
            : "Acción creada correctamente."
        );
        if (userPk) {
          setSar(undefined);
          fetchActionsList();
          resetForm();
        }
      })
      .catch((error) => {
        console.error("Error saving action:", error);
        toastError("Error al guardar la acción.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (sar) {
      toogleModalChangeHoursAndRecertification();
    } else {
      saveData();
    }
  };

  const fetchActionsList = () => {
    authenticatedFetcher({
      path: `/sar/${userPk}/list/`,
      urlParams: {
        nitems: 500,
      },
    }).then((response) => {
      setActionsList(response);
    });
  };
  const fetchActionPerson = () => {
    authenticatedFetcher({
      path: "/persons/",
      urlParams: {
        is_staff: 1,
        nitems: 500,
        order: "full_name",
        order_type: "asc",
      },
    }).then((response) => {
      setActionPersonList([{}, ...response]);
    });
  };
  const fetchContactTypes = () => {
    authenticatedFetcher({
      path: "/sar/contact-types/",
      urlParams: {
        nitems: 500,
      },
    }).then((response) => {
      setContactTypesList([{}, ...response]);
    });
  };
  const fetchDefaultAnswers = () => {
    authenticatedFetcher({
      path: "/sar/default-answers/",
      urlParams: {
        nitems: 500,
      },
    }).then((response) => {
      setDefaultAnswerList([{}, ...response]);
    });
  };
  const fetchRecertificationActualGroups = () => {
    authenticatedFetcher({
      path: `/persons/${userPk}/actual-recertification-groups/`,
      urlParams: {
        nitems: 500,
      },
    }).then((response) => {
      setRecertificationGroupList([{}, ...response]);
    });
  };
  const fetchRecertificationGroups = () => {
    authenticatedFetcher({
      path: "/persons/recertification-group/",
      urlParams: {
        nitems: 500,
        person: userPk,
      },
    }).then((response) => {
      setRecertificationGroupList([{}, ...response]);
    });
  };
  const fetchDepartments = () => {
    authenticatedFetcher({
      path: "/sar/departments/",
      urlParams: {
        nitems: 500,
      },
    }).then((response) => {
      setDepartmentList([{}, ...response]);
    });
  };
  const getAction = (sarId, index) => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;
    setIsLoading(true);
    setSar(undefined);
    authenticatedFetcher({
      path: `/sar/${sarId}`,
    })
      .then((response) => {
        setSarIndex(index);
        const newCreationDate = new Date(response.created_at);
        const newCreationDatePlus15 = new Date(response.created_at);
        setCreationDate(response.action_date);
        setCreationDatePlus15(
          newCreationDatePlus15.setDate(newCreationDate.getDate() + 15),
        );
        setSelectedActionPerson(response.action_person);
        setSelectedContactType(response.contact_type);
        setSelectedDefaultAnswer(response.default_answer);
        setSelectedRecertificationGroup(response.recertification_group);
        setControlDate(response.control_date);
        setSelectedDepartment(response.department);
        setComments(response.comments);
        setSar(response);
        setPublicAction(response.is_private ? "0" : "1");
        setSelectedEntity(
          response.enterprise === null && response.enterprise_name
            ? "-1"
            : response.enterprise === null && !response.enterprise_name
              ? ""
              : response.enterprise,
        );
        setEnterpriseName(response.enterprise_name);
        fetchActionsList();
        fetchRecertificationGroups();
      })
      .finally(() => {
        isFetchingRef.current = false;
        setIsLoading(false);
      });
  };

  const handleDeleteAction = () => {
    setIsLoading(true);
    authenticatedFetcher({
      path: `/sar/${sar.id}`,
      method: "DELETE",
    })
      .then(() => {
        toastSuccess("Acción borrada con éxito.");
        setSar(undefined);
        fetchActionsList();
        resetForm();
      })
      .catch((error) => {
        console.error("Error deleting action:", error);
        toastError("Error al borrar la acción.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleOnInit = (editor) => {
    editorRef.current = editor;
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return new ckUploader(loader);
    };
    try {
      editor.setData(comments || "");
    } catch (e) {
      console.log("Error setting data", e);
    }
  };

  const handleChangeEditor = (event, editor) => {
    if (isResettingRef.current) return;
    const data = editor.getData();
    setComments(data);
  };

  useEffect(() => {
    if (!editorRef.current) return;
    try {
      const currentData = editorRef.current.getData();
      if ((comments || "") !== (currentData || "")) {
        editorRef.current.setData(comments || "");
      }
    } catch (e) {
      console.log("Error setting data", e);
    }
  }, [comments]);

  const resetForm = () => {
    isResettingRef.current = true;
    if (userPk) {
      fetchRecertificationActualGroups();
    }
    setSelectedContactType("");
    setSelectedActionPerson("");
    setSelectedDefaultAnswer("");
    setSelectedRecertificationGroup("");
    setSelectedDepartment("");
    setComments("");
    setSar(undefined);
    setControlDate("");
    setSelectedEntity("");
    setEnterpriseName("");
    setPublicAction("");
    setCreationDate(new Date());
    setTimeout(() => {
      isResettingRef.current = false;
    }, 0);
  };

  const fetchPersonData = () => {
    authenticatedFetcher({
      path: `/persons/${userPk}/sar-person-data/`,
    }).then((response) => {
      setUserData(response);
      if (response.enterprise_id && response.enterprise_name) {
        setEntitiesList([
          {
            pk: response.enterprise_id,
            name: response.enterprise_name,
          },
          {
            pk: -1,
            name: "Otra",
          },
        ]);
        setSelectedEntity((prev) =>
          prev === "" || prev === undefined
            ? String(response.enterprise_id)
            : prev,
        );
      }
    });
  };

  const getHours = () => {
    if (sar && sar.certification_name) {
      return (
        userData?.[
          `${sar.certification_name.toLowerCase() !== "seguros" ? sar.certification_name.toLowerCase() : "insurance"}_data`
        ]?.hours_performed ?? 0
      );
    }
    if (
      !sar &&
      selectedRecertificationGroup &&
      selectedRecertificationGroup !== "" &&
      userData
    ) {
      const recertificationGroup = recertificationGroupList.find(
        (item) => item.pk === parseInt(selectedRecertificationGroup),
      );
      if (recertificationGroup) {
        const recertificationGroupName =
          recertificationGroup.recertification_certification_name?.toLowerCase();
        if (recertificationGroupName && !recertificationGroupName.includes("seguros")) {
          return (
            userData?.[`${recertificationGroupName}_data`]?.hours_performed ?? 0
          );
        } else {
          return userData?.insurance_data?.hours_performed ?? 0;
        }
      }
    }
    return 0;
  };

  useEffect(() => {
    resetForm();
    setActionsList([]);
    if (userPk) {
      fetchActionsList();
      if (sar) {
        fetchRecertificationGroups();
      } else {
        fetchRecertificationActualGroups();
      }
      fetchActionPerson();
      fetchContactTypes();
      fetchDefaultAnswers();
      fetchDepartments();
      fetchPersonData();
    }
  }, [userPk]);

  useEffect(() => {
    if (!sar || !userPk) return;
    const handleKeyDown = (event) => {
      if (isFetchingRef.current) return;
      if (
        ["INPUT", "TEXTAREA", "SELECT"].includes(event.target.tagName) ||
        event.target.isContentEditable ||
        (event.target.closest && event.target.closest(".ck-editor"))
      ) {
        return;
      }

      if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
        event.preventDefault();
        if (sarIndex === actionsList.length - 1 && event.key === "ArrowRight")
          return;
        if (sarIndex === 0 && event.key === "ArrowLeft") return;
        const newSearchIndex =
          event.key === "ArrowRight" ? sarIndex + 1 : sarIndex - 1;
        const action = actionsList[newSearchIndex];
        getAction(action.pk, newSearchIndex);
        document.getElementById(`action-row-${newSearchIndex}`).scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [sar, userPk, sarIndex, actionsList]);
  return (
    <div className="card-body">
      <form onSubmit={onSubmit}>
        <div className="form-row">
          <div className="col-md-4 form-group">
            <label htmlFor="dataAccio">Fecha Acción</label>
            <input
              type="date"
              className="form-control BasicInput"
              id="dataAccio"
              value={creationDate}
              onChange={handleChangeCreationDate}
            />

            <label htmlFor="usuari" className="mt-2">
              Usuario
            </label>
            <select
              className="form-control BasicInput"
              aria-label=".form-select-lg example"
              value={selectedActionPerson}
              onChange={handleChangeSelectedActionPerson}
            >
              {actionPersonList.map((item) => {
                return (
                  <option key={item.pk} value={item.pk}>
                    {item.full_name}
                  </option>
                );
              })}
            </select>

            <label htmlFor="accionNoPublica" className="mt-2">
              ¿Acción NO pública?
            </label>
            <select
              className="form-control BasicInput"
              aria-label=".form-select-lg example"
              id="accionNoPublica"
              value={isPublicAction}
              onChange={handleChangeIsPublicAction}
            >
              <option value=""></option>
              <option value="0">No</option>
              <option value="1">Si</option>
            </select>

            <label htmlFor="canal" className="mt-2">
              Canal
            </label>
            <select
              className="form-control BasicInput"
              aria-label=".form-select-lg example"
              id="canal"
              value={selectedContactType}
              onChange={handleChangeSelectedContactType}
            >
              {contactTypesList.map((item) => {
                return (
                  <option key={item.pk} value={item.pk}>
                    {item.name}
                  </option>
                );
              })}
            </select>

            <label htmlFor="respostaPredeterminada" className="mt-2">
              Respuesta predeterminada
            </label>
            <select
              className="form-control BasicInput"
              aria-label=".form-select-lg example"
              id="respostaPredeterminada"
              value={selectedDefaultAnswer}
              onChange={handleChangeSelectedDefaultAnswer}
            >
              <option key="-" value=""></option>
              {defaultAnswerList.map((item) => {
                return (
                  <option key={item.pk} value={item.pk}>
                    {item.name}
                  </option>
                );
              })}
            </select>

            <label htmlFor="dataControl" className="mt-2">
              Recertificación
            </label>
            <select
              className="form-control BasicInput"
              aria-label=".form-select-lg example"
              id="dataControl"
              value={selectedRecertificationGroup}
              onChange={handleChangeSelectedRecertificationGroup}
            >
              {recertificationGroupList.map((item) => {
                return (
                  <option key={item.pk} value={item.pk}>
                    {item.recertification_batch_name}
                  </option>
                );
              })}
            </select>

            <label htmlFor="dataControl2" className="mt-2">
              Fecha Control
            </label>
            <input
              type="date"
              className="form-control BasicInput"
              id="dataControl2"
              value={controlDate}
              onChange={handleControlDateChange}
            />
            <label htmlFor="departamento" className="mt-2">
              Departamento
            </label>
            <select
              className="form-control BasicInput"
              aria-label=".form-select-lg example"
              id="departamento"
              value={selectedDepartment}
              onChange={handleChangeSelectedDepartment}
            >
              {departmentList.map((item) => {
                return (
                  <option key={item.pk} value={item.pk}>
                    {item.name}
                  </option>
                );
              })}
            </select>
            <label htmlFor="departamento" className="mt-2">
              Entidad
            </label>
            <select
              className="form-control BasicInput"
              aria-label=".form-select-lg example"
              id="entidad"
              value={selectedEntity}
              onChange={handleChangeSelectedEntity}
            >
              {entitiesList.map((item) => {
                return (
                  <option key={item.pk} value={item.pk}>
                    {item.name}
                  </option>
                );
              })}
            </select>
            {selectedEntity === "-1" && (
              <>
                <br />
                <input
                  type="default"
                  className="form-control BasicInput"
                  id="enterpsise_name"
                  value={enterpriseName}
                  onChange={handleChangeEnterpsiseName}
                />
              </>
            )}
            {sar && (
              <>
                <label htmlFor="hours" className="mt-2">
                  Horas
                </label>
                <input
                  type="default"
                  className="form-control BasicInput"
                  id="hours"
                  value={sar?.hours}
                  readOnly
                />
                <label htmlFor="cert" className="mt-2">
                  Certificado
                </label>
                <input
                  type="default"
                  className="form-control BasicInput"
                  id="cert"
                  value={sar?.certification_name}
                  readOnly
                />
              </>
            )}
          </div>

          <div className="col-md-8 form-group">
            {userPk && (
              <div
                tabIndex={-1}
                style={{ maxHeight: "250px", marginBottom: "10px" }}
                className="table-responsive mt-3"
              >
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          paddingBlock: 5,
                        }}
                      >
                        Acción
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          paddingBlock: 5,
                        }}
                      >
                        Usuario
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          paddingBlock: 5,
                        }}
                      >
                        Canal
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          paddingBlock: 5,
                        }}
                      >
                        Respuesta Predeterminada
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          paddingBlock: 5,
                        }}
                      >
                        Control
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          paddingBlock: 5,
                        }}
                      >
                        Horas
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          paddingBlock: 5,
                        }}
                      >
                        Certificación
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ overflowY: "auto" }}>
                    {actionsList &&
                      actionsList.map((item, index) => {
                        const isSelected = sar && sar.id === item.pk;
                        return (
                          <tr
                            key={item.pk || index}
                            id={`action-row-${index}`}
                            style={{
                              backgroundColor: isSelected ? "yellow" : "white",
                            }}
                          >
                            <td
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                paddingBlock: 0,
                              }}
                            >
                              <button
                                tabIndex={-1}
                                type="button"
                                className="btn"
                                style={{
                                  fontSize: 11,
                                  textDecoration: "underline",
                                  color: "blue",
                                }}
                                onClick={() => getAction(item.pk, index)}
                              >
                                {item.action_date}
                              </button>
                            </td>
                            <td
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                paddingBlock: 0,
                              }}
                            >
                              {item.action_person_name}
                            </td>
                            <td
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                paddingBlock: 0,
                              }}
                            >
                              {item.contact_type_name}
                            </td>
                            <td
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                paddingBlock: 0,
                              }}
                            >
                              {item.default_answer_name}
                            </td>
                            <td
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                paddingBlock: 0,
                              }}
                            >
                              {item.control_date}
                            </td>
                            <td
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                paddingBlock: 0,
                              }}
                            >
                              {item.hours}
                            </td>
                            <td
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                paddingBlock: 0,
                              }}
                            >
                              {item.certification_name}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
            <label htmlFor="observacions">Observaciones</label>
            <CKEditor
              key={editorId}
              editor={Editor}
              id={editorId}
              data={comments}
              onReady={handleOnInit}
              onChange={handleChangeEditor}
              name="observacions"
              config={config}
            />
          </div>
        </div>
        <div className="text-right mt-3">
          <button
            style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
            type="button"
            className="btn btn-secondary mr-1"
            onClick={resetForm}
            disabled={isLoading}
          >
            Vaciar
          </button>
          <button
            style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
            type="submit"
            className="btn btn-secondary mr-1"
            disabled={isLoading}
          >
            {isLoading ? "Cargando..." : "Guardar"}
          </button>
          {sar && creationDatePlus15 >= new Date() ? (
            <button
              style={{
                cursor: isLoading ? "not-allowed" : "pointer",
                backgroundColor: isLoading ? "#ffcccc" : "red",
                color: "white",
              }}
              type="button"
              className="btn btn-secondary mr-1"
              onClick={handleDeleteAction}
              disabled={isLoading}
            >
              {isLoading ? "Borrando..." : "Borrar"}
            </button>
          ) : null}
        </div>
      </form>
      <CustomModalSARChangeHoursAndRecertification
        toggle={toogleModalChangeHoursAndRecertification}
        open={changeHoursAndRecertificationModalOpen}
        onSave={saveData}
      />
    </div>
  );
};
